// pagina usuarios (contiene la lista de usuarios)

import React from 'react';
import EmployeeList from '../components/EmployeeList';

export default function Users() {       
  return (
    <div>
      <section>
        <EmployeeList />
      </section>
    </div>
  );
} 